import { Component, Input, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';

import { HttpErrorStatuses } from '~shared/modules/error-handler';
import { environment } from '~env/environment';
import { MEDIA_ALISES } from '~shared/constants/media.constant';

@Component({
  selector: 'app-error-page',
  styleUrls: ['./error-page.component.scss'],
  templateUrl: './error-page.component.html'
})
export class ErrorPageComponent implements OnInit {
  @Input() errorStatus: number;
  errorStyles: { [key: string]: string };
  constructor(private mediaObserver$: MediaObserver) {}

  ngOnInit() {
    this.errorStyles = this.getErrorPageStyles();
  }

  private getErrorPageStyles(): { [key: string]: string } {
    const status = this.errorStatus || HttpErrorStatuses.NotFound;
    const platform = this.mediaObserver$.isActive(MEDIA_ALISES.mobile) ? 'mobile' : 'desktop';

    return {
      'background-image': `url(${environment.cdnBaseUrl()}/images/${status}_${platform}.svg)`,
    };
  }
}
